import { useGetTrackedPropertiesByOrganizationCountQuery } from "gql/generated.graphql";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { useCallback, useContext, useMemo } from "react";
import {
  DatePeriodTypesEnum,
  FilterContext,
  getPeriodRangeByPeriodType,
} from 'dash-ui';
import DashboardWidgetContainer from "../DashboardWidgetContainer/DashboardWidgetContainer";


const DashboardWidgetPropertySave = () => {
  const theme = useTheme();
  const { t } = useTranslation('pages');
  const { state: filterState } = useContext(FilterContext);

  const { data: dataPeriod, loading: loadingPeriod } =
    useGetTrackedPropertiesByOrganizationCountQuery({
      variables: {
        filter: {
          propertyIds: filterState?.propertyId ? [filterState?.propertyId] : [],
          propertyUpdatesRange: filterState.dateRange
            ? {
                startDate: filterState.dateRange?.startDate,
                endDate: filterState.dateRange?.endDate,
              }
            : getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK),
        },
      }
    });

  const { countPeriod } = useMemo(
    () => ({
      countPeriod: dataPeriod?.getTrackedPropertiesByOrganizationCount || 0,
    }),
    [dataPeriod]
  );

  const { data, loading } =
    useGetTrackedPropertiesByOrganizationCountQuery({
      variables: {
        filter: {
          propertyIds: filterState?.propertyId ? [filterState?.propertyId] : [],
        },
      }
    });

  const { count } = useMemo(
    () => ({
      count: data?.getTrackedPropertiesByOrganizationCount || 0,
    }),
    [data]
  );

  const makePlaceholderText = useCallback(() => {
    if (count === 0) {
      return t('organizationDashboardPage.propertySavesPlaceholderText') || '';
    }
    return t('organizationDashboardPage.propertySavesPlaceholderTextPeriod') || '';
  }, [count, t])

  return (
    <DashboardWidgetContainer
      bgColor={theme.colors.b50}
      placeholderTitle={
        t('organizationDashboardPage.propertySavesPlaceholderTitle') || ''
      }
      placeholderText={makePlaceholderText()}
      icon="libraryAddCheck"
      count={countPeriod}
      loading={loadingPeriod && loading}
    />
  )
}

export default DashboardWidgetPropertySave;
